import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css'; // Global stilleri import et
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext'; // AuthContext'i import et

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider> {/* Uygulamayı AuthProvider ile sarmala */}
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);